export default {"src":"/_next/static/media/twitter-bold.15e7c6f6.svg","height":19,"width":22,"blurWidth":0,"blurHeight":0};